<div class="fdd-anomalies-tab">
  @if (fieldId) {
    <app-anomalies-list
      [compactLayout]="true"
      [appliedFilters]="appliedFilters"
    ></app-anomalies-list>
  }
</div>
